module.exports = __webpack_public_path__ + "img/xhs.704008c2.png";